import { gql } from '@apollo/client';

export type AvatarInput = {
  name: string;
  description: string;
  validTill: Date | null;
  organizations: string[];
  isEnabledForAllOrgs: boolean;
  tenants: string[];
  createdBy: string;
  starCost: string;
  genders: string[];
  category: string;
};

export type CompleteAvatarUploadInput = {
  uploadId: string;
  avatarInput: AvatarInput;
};

export type CompleteAvatarUploadResponse = {
  completePredefinedAvatarUpload: {
    status: string;
  };
};

export enum AvatarUploadStatus {
  FAILED,
  SUCCESSFUL,
}

export type AvatarUploadCompletion = {
  status: AvatarUploadStatus;
};

export const COMPLETE_AVATAR_UPLOAD = gql`
  mutation CompletePredefinedAvatarUpload(
    $uploadId: UUID!
    $avatarInput: PredefinedAvatarInput!
  ) {
    completePredefinedAvatarUpload(
      uploadId: $uploadId
      avatarInput: $avatarInput
    ) {
      status
    }
  }
`;
